import { PaymentMethod, tabTypeToPaymentMethodMap } from '../constants';
import getFallbackPaymentTab from './convertTrimsDataToCardProps/getFallbackPaymentTab';
import getPreferredSpecialOffersLoyaltyKey from './getPreferredSpecialOffersLoyaltyKey';
const getDefaultSpecialOffersPaymentOptions = (trim, config, paymentMethod) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { validPaymentTabs, fallbackPaymentFrequency, fallbackPaymentTerm } = config;
    let defaultFrequency = fallbackPaymentFrequency;
    let defaultTerm = fallbackPaymentTerm[PaymentMethod.lease];
    let defaultDownPayment = 0;
    let defaultIncentiveOffers = [];
    let loyaltyOfferKey = '';
    const { financials: { defaultPaymentMethod, defaultLeasePaymentFrequency, defaultLeasePaymentTerm, defaultFinancePaymentFrequency, defaultFinancePaymentTerm, financeDownPayment, leaseDownPayment, }, offers, } = trim;
    const { incentiveOffers: { cash: cashIncentiveOffers, finance: financeIncentiveOffers, lease: leaseIncentiveOffers }, loyaltyOffers: { cash: cashLoyaltyOffers, finance: financeLoyaltyOffers, lease: leaseLoyaltyOffers }, } = offers;
    const fallBackPaymentMethod = tabTypeToPaymentMethodMap[getFallbackPaymentTab(offers, validPaymentTabs)];
    const derivedPaymentMethod = paymentMethod || defaultPaymentMethod || fallBackPaymentMethod;
    switch (derivedPaymentMethod) {
        case PaymentMethod.lease:
            defaultFrequency = defaultLeasePaymentFrequency || fallbackPaymentFrequency;
            defaultTerm =
                (_b = (_a = trim.specialRates[derivedPaymentMethod]) === null || _a === void 0 ? void 0 : _a.term) !== null && _b !== void 0 ? _b : (Number(defaultLeasePaymentTerm) || Number(fallbackPaymentTerm[PaymentMethod.lease]));
            defaultDownPayment = Number(leaseDownPayment);
            defaultIncentiveOffers = (_c = leaseIncentiveOffers === null || leaseIncentiveOffers === void 0 ? void 0 : leaseIncentiveOffers.map(({ id }) => id)) !== null && _c !== void 0 ? _c : [];
            loyaltyOfferKey = getPreferredSpecialOffersLoyaltyKey(leaseLoyaltyOffers !== null && leaseLoyaltyOffers !== void 0 ? leaseLoyaltyOffers : []);
            break;
        case PaymentMethod.finance:
            defaultFrequency = defaultFinancePaymentFrequency || fallbackPaymentFrequency;
            defaultTerm =
                (_e = (_d = trim.specialRates[derivedPaymentMethod]) === null || _d === void 0 ? void 0 : _d.term) !== null && _e !== void 0 ? _e : (Number(defaultFinancePaymentTerm) || Number(fallbackPaymentTerm[PaymentMethod.lease]));
            defaultDownPayment = Number(financeDownPayment);
            defaultIncentiveOffers = (_f = financeIncentiveOffers === null || financeIncentiveOffers === void 0 ? void 0 : financeIncentiveOffers.map(({ id }) => id)) !== null && _f !== void 0 ? _f : [];
            loyaltyOfferKey = getPreferredSpecialOffersLoyaltyKey(financeLoyaltyOffers !== null && financeLoyaltyOffers !== void 0 ? financeLoyaltyOffers : []);
            break;
        case PaymentMethod.cash:
            defaultIncentiveOffers = (_g = cashIncentiveOffers === null || cashIncentiveOffers === void 0 ? void 0 : cashIncentiveOffers.map(({ id }) => id)) !== null && _g !== void 0 ? _g : [];
            loyaltyOfferKey = getPreferredSpecialOffersLoyaltyKey(cashLoyaltyOffers !== null && cashLoyaltyOffers !== void 0 ? cashLoyaltyOffers : []);
            break;
        default:
            break;
    }
    return {
        defaultPaymentMethod: derivedPaymentMethod,
        defaultFrequency,
        defaultTerm,
        defaultDownPayment,
        defaultIncentiveOffers,
        loyaltyOfferKey,
    };
};
export default getDefaultSpecialOffersPaymentOptions;
